import type { Acknowledgement } from '@api-client/dashboard';
import type { CompanyInfo, Profile, ProfileFlag } from '@api-client/profiles';

interface CompanyInfoOverride extends CompanyInfo {
    at_licenseHolderInstituteId?: number;
}

const CustomProfileFlag: Record<string, string> = {
    CZ_SECURITIES_CHANGES_DISALLOWED: 'cz-securityChangesDisallowed',
    SECURITIES_TRADING_ALLOWED: 'securitiesTradingAllowed',
    GEORGE_EVENTS_ALLOWED: 'georgeEventsAllowed',
} as const;

const ProfileFlag: Record<string, ProfileFlag> = {
    DATA_CONSENT_ACTION_REQUIRED: 'dataConsentActionRequired',
    MULTIPLE_PROFILES: 'multipleProfiles',
    MULTIPLE_PROFILES_DISPLAY_DISABLED: 'multipleProfilesDisplayDisabled',
    TAX_RESIDENCES_ACTION_REQUIRED: 'taxResidencesActionRequired',
    COLLECTIVE_SIGNING: 'collectiveSigning',
    BANK_SYSTEM_PROCESSING_PAUSE: 'bankSystemProcessingPause',
    BANK_SYSTEM_FUNCTIONALITY_READ_ONLY: 'bankSystemFunctionalityReadOnly',
    GEORGE_ID_MIGRATION_REQUESTED: 'georgeIdMigrationRequested',
    GEORGE_ID_MIGRATION_MANDATORY: 'georgeIdMigrationMandatory',
    FIT_ENABLED: 'fitEnabled',
    USER_TOO_YOUNG_FOR_RECOMMENDATION: 'userTooYoungForRecommendation',
    USER_BLACKLISTED_FOR_RECOMMENDATION: 'userBlacklistedForRecommendation',
    JUNIOR: 'junior',
    JUNIOR_UPGRADE_UPCOMING: 'juniorUpgradeUpcoming',
    CONTACT_DATA_CONFIRMATION_REQUIRED: 'contactDataConfirmationRequired',
    KYC_QUESTIONNAIRE_REQUIRED: 'kycQuestionnaireRequired',
    KYC_QUESTIONNAIRE_REQUESTED: 'kycQuestionnaireRequested',
    GEORGE_PRO: 'georgePro',
    ON_BEHALF_SESSION: 'onBehalfSession',
    PERSONETICS_ENABLED: 'personeticsEnabled',
    GEORGE_EVENTS_ALLOWED: 'georgeEventsAllowed',
    FINANCIAL_HEALTH_LOYALTY_ENABLED: 'financialHealthLoyaltyEnabled',
    HEY_GEORGE_DISABLED: 'heyGeorgeDisabled',
} as const;

export const ProfileFlags: Record<string, ProfileFlag | string> = {
    ...CustomProfileFlag,
    ...ProfileFlag,
} as const;

export type ProfileFlags = ProfileFlag | string;

type MyProfileOverwrite = {
    acknowledgements?: Acknowledgement[];
    offlineKey?: string;
    instituteInfo?: {
        address: string;
        longName: string;
        shortName: string;
        sortCode: string;
    };
    'ro-onboarding'?: {
        url: string;
    };
    'sk-onboarding'?: {
        url: string;
    };
    'at-lastCardTanReaderOrderDate'?: string;
    georgeValidUntilDate?: string;
    companyInfo?: CompanyInfoOverride;
    flags?: ProfileFlags[];
    userRoles?: string[];
};

export type MyProfile = Omit<Profile, 'flags'> & Partial<MyProfileOverwrite>;
